import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          精选专题
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-semibold bg-accent-500 text-background-50 rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}